module.exports = __webpack_public_path__ + "media/images/subject_img/EDUCATION-7cfd0e12c0e331da75392e191dce027a.jpg";